/* eslint-disable jsx-a11y/media-has-caption */
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

import styles from '../../styles/partials/video.module.css';

interface VideoProps {
    url?: string | null;
    medias?: {
        url?: string | null;
        mime?: string | null;
    }[];
    thumbnail?: string | null;
    autoPlay?: boolean;
    isPoster?: boolean;
    className?: string | null;
}

const Video = ({
    url = null,
    medias = null,
    thumbnail = null,
    autoPlay = true,
    isPoster = false,
    className = null,
}: VideoProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const reducedMotion = usePrefersReducedMotion();

    useEffect(() => {
        const videoElement = videoRef.current || null;
        if (reducedMotion && videoElement !== null) {
            videoElement.pause();
        }
    }, [reducedMotion]);

    return url !== null || thumbnail !== null || (medias !== null && medias.length > 0) ? (
        <video
            className={classNames([
                styles.container,
                styles.video,
                { [className]: className !== null },
            ])}
            ref={videoRef}
            src={!isPoster && url !== null ? `${url}#t=0.01` : null}
            poster={thumbnail}
            autoPlay={autoPlay && !isPoster && !reducedMotion}
            loop
            muted
            playsInline
            preload="auto"
            aria-hidden="true"
            tabIndex={-1}
        >
            {(medias || []).map((media, index) =>
                media.url !== null && media.mime !== null ? (
                    <source key={index} src={media.url} type={media.mime} />
                ) : null,
            )}
        </video>
    ) : null;
};

export default Video;
